import { Badge } from "@/components/ui/badge"
import { Button } from "@/components/ui/button"
import {
  Card,
  CardAction,
  CardDescription,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from "@/components/ui/drawer"
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"
import { Vipiska } from "@/components/polis/vipiska"

export function CardSmall({ data }) {
  return (
    <>
      {
        data.map((item) => {
          console.log(item)
          return (
            <Card key={item.id} className="relative mx-auto my-4 w-full max-w-sm pt-2">
              <CardContent className="px-2 mt-0 flex flex-col">
                <div className='border-b mb-2 px-2 flex flex-row justify-between'>
                  <CardTitle className="mb-2 mt-1 text-[#193C6D]">
                    Полис ОМС
                  </CardTitle>
                </div>
                <div>{item.ENP}</div>
                <div>{item.FAM} {item.IM} {item.OT}</div>
                <div className="text-green-700 text-[15px] mt-2">{item.DATEEND}</div>
              </CardContent>
              <CardFooter className="px-2">
                <TableCellViewer item={item} />

              </CardFooter>
            </Card>
          )
        })
      }
    </>
  )
}

function TableCellViewer({ item }) {
  return (

    <Dialog>
      <DialogTrigger className="w-full">
        <Button className="w-full">Выписка</Button>
      </DialogTrigger>
      <DialogContent className="max-w-full h-full sm:max-w-auto py-0 px-0">
        <DialogHeader className="text-center bg-[#193C6D] text-white p-1 m-0">
          <DialogTitle >Выписка</DialogTitle>
          <DialogDescription className="text-white">
            из единого регистра застрахованных лиц
          </DialogDescription>
        </DialogHeader>

        <div className="flex flex-col gap-4 overflow-y-auto text-sm">
          < Vipiska ENP={item.ENP} LPU={item.LPU} />
        </div>

      </DialogContent>

    </Dialog>

  )
}
